<template>
  <div class="section section_big-padding-top section_big-padding-bottom">
    <div class="max-width">
      <div class="advanced__features">
        <div class="advanced__item fadeIn">
          <div class="advanced__pic"><img loading="lazy" srcset="/assets/imgs/themes/zap/advanced-1.webp 1x, /assets/imgs/themes/zap/advanced-1@2x.webp 2x" src="/assets/imgs/themes/zap/advanced-1.webp"></div>
          <div class="advanced__about">
            <div class="advanced__label">Visually Magnetic Design</div>
            <div class="advanced__text">Bold typography, clean layouts, promo banners, full-screen before/after, and animated text designed to engage and impress.</div>
          </div>
        </div>
        <div class="advanced__item fadeIn">
          <div class="advanced__pic"><img loading="lazy" srcset="/assets/imgs/themes/zap/advanced-2.webp 1x, /assets/imgs/themes/zap/advanced-2@2x.webp 2x" src="/assets/imgs/themes/zap/advanced-2.webp"></div>
          <div class="advanced__about">
            <div class="advanced__label">Sales-Optimized Features</div>
            <div class="advanced__text">All-in-one conversion tools — quick view, popups, age verifier, product search, cart drawer, and catalog — to maximize revenue.</div>
          </div>
        </div>
        <div class="advanced__item fadeIn">
          <div class="advanced__pic"><img loading="lazy" srcset="/assets/imgs/themes/zap/advanced-3.webp 1x, /assets/imgs/themes/zap/advanced-3@2x.webp 2x" src="/assets/imgs/themes/zap/advanced-3.webp"></div>
          <div class="advanced__about">
            <div class="advanced__label">Seamless User Journey</div>
            <div class="advanced__text">Intuitive navigation that keeps customers engaged at every step, guiding them smoothly through browsing, discovery, and selection to a seamless checkout.</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="section section_big-padding-top section_gray">
    <div class="advanced">
      <div class="max-width">
        <div class="section__head section__head_middle">
          <div class="section__subheading fadeIn">{{ subheading }}</div>
          <h2 class="section__title">{{ title }}</h2>
          <div class="section__text">{{ text }}</div>
        </div>
      </div>

      <div class="advanced__slider">
        <div class="scroll-banner">
          <div class="scroll-banner__track">
            <img loading="lazy" srcset="/assets/imgs/themes/zap/advanced-scroller.webp 1x, /assets/imgs/themes/zap/advanced-scroller@2x.webp 2x" src="/assets/imgs/themes/zap/advanced-scroller.webp">
            <img loading="lazy" srcset="/assets/imgs/themes/zap/advanced-scroller.webp 1x, /assets/imgs/themes/zap/advanced-scroller@2x.webp 2x" src="/assets/imgs/themes/zap/advanced-scroller.webp">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdvancedView',
  props: {
    subheading: { type: String, required: true },
    title: { type: String, required: true },
    text: { type: String, required: true }
  }
}
</script>

<style lang="scss">
.advanced {
  .section__head {
    margin-bottom:0;
  }

  &__slider {
    margin:3.5rem 0 2rem;

    @include md {
      margin:2.5rem 0 0;
    }

    img {
      filter: drop-shadow(0 0 17px rgba(127, 127, 127, 0.1));
    }

    .scroll-banner {
      position: relative;
      overflow: hidden;
      width: 100%;
      height: auto;
      --image-width: 2566px;
      --scroll-speed:40s;
      padding:3rem 0;
      margin:-3rem 0;

      @include md {
        --image-width: 1100px;
      }

      &__track {
        display: flex;
        width: calc(var(--image-width) * 2);
        animation: scroll-x linear infinite;
        animation-duration: var(--scroll-speed);
        gap:1.5rem;

        img {
          width: var(--image-width);
          height: auto;
          flex-shrink: 0;
          object-fit: cover;
          -webkit-user-drag: none;
          user-select: none;
          pointer-events: none;
        }
      }
    }

    @keyframes scroll-x {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(calc(-50% - 1.5rem));
      }
    }
  }

  &__features {
    display:grid;
    grid-template-columns:repeat(3,1fr);
    gap:1.25rem;

    @include md {
      grid-template-columns:repeat(1,1fr);
    }
  }

  &__item {
    background:var(--color-gray-light);
    border-radius:1.5rem;
    overflow:hidden;

    @include md {
      display:flex;
    }

    @include xs {
      flex-direction:column;
    }
  }

  &__pic {
    @include md {
      flex:none;
      width:52%;
    }

    @include xs {
      width:100%;
    }
  }

  &__about {
    padding:2rem 2rem 2.5rem;

    @include md {
      padding:2rem;
    }

    @include xs {
      padding:1.5rem;
    }
  }

  &__label {
    font-weight: 900;
    font-size:1.5rem;
    line-height:1.3;
    text-transform: uppercase;
    margin:0 0 .5rem;

    @include md {
      font-size:1.125rem;
    }
  }

  &__text {
    max-width:404px;
    font-size:1rem;

    @include md {
      font-size:.875rem;
    }
  }
}
</style>
